import { gql } from '@apollo/client'

export const ResendInvite = gql`
    mutation ResendInvite($inviteId: ID!) {
        resendInvite(inviteId: $inviteId)
    }
`

export default ResendInvite
